// Override manual de ciudades por país. Se fusiona con el catálogo de
// `country-state-city` en NewProyectoForm para cubrir faltantes (ej. Colima,
// Manzanillo, Veracruz, Querétaro, etc.).
//
// Formato: { [countryName]: string[] }
// El countryName debe coincidir con el `name` que devuelve Country.getAllCountries().

export const cityOverrides = {
  Mexico: [
    // Aguascalientes
    "Aguascalientes", "Jesús María", "Calvillo",
    // Baja California
    "Mexicali", "Tijuana", "Ensenada", "Tecate", "Playas de Rosarito",
    // Baja California Sur
    "La Paz", "Los Cabos", "San José del Cabo", "Cabo San Lucas", "Loreto",
    // Campeche
    "Campeche", "Ciudad del Carmen", "Champotón",
    // Chiapas
    "Tuxtla Gutiérrez", "San Cristóbal de las Casas", "Tapachula", "Palenque", "Comitán",
    // Chihuahua
    "Chihuahua", "Ciudad Juárez", "Delicias", "Cuauhtémoc", "Hidalgo del Parral", "Nuevo Casas Grandes",
    // Coahuila
    "Saltillo", "Torreón", "Monclova", "Piedras Negras", "Ciudad Acuña", "Sabinas", "San Pedro",
    // Colima
    "Colima", "Manzanillo", "Tecomán", "Villa de Álvarez", "Comala", "Coquimatlán",
    // Durango
    "Durango", "Gómez Palacio", "Lerdo",
    // Estado de México
    "Toluca", "Metepec", "Ecatepec de Morelos", "Naucalpan de Juárez", "Tlalnepantla de Baz",
    "Cuautitlán Izcalli", "Ciudad Nezahualcóyotl", "Atizapán de Zaragoza", "Chalco",
    "Ixtapaluca", "Texcoco", "Valle de Bravo", "Tultitlán", "Coacalco", "Chimalhuacán",
    // Ciudad de México (alcaldías)
    "Ciudad de México", "Álvaro Obregón", "Azcapotzalco", "Benito Juárez", "Coyoacán",
    "Cuajimalpa", "Cuauhtémoc", "Gustavo A. Madero", "Iztacalco", "Iztapalapa",
    "Magdalena Contreras", "Miguel Hidalgo", "Milpa Alta", "Tláhuac", "Tlalpan",
    "Venustiano Carranza", "Xochimilco",
    // Guanajuato
    "Guanajuato", "León", "Celaya", "Irapuato", "Salamanca", "Silao",
    "San Miguel de Allende", "Pénjamo", "Dolores Hidalgo", "San Francisco del Rincón",
    // Guerrero
    "Chilpancingo", "Acapulco", "Iguala", "Taxco", "Zihuatanejo", "Ixtapa",
    // Hidalgo
    "Pachuca", "Tulancingo", "Tula de Allende", "Tizayuca", "Mineral de la Reforma",
    // Jalisco
    "Guadalajara", "Zapopan", "San Pedro Tlaquepaque", "Tonalá", "Tlajomulco de Zúñiga",
    "Puerto Vallarta", "Lagos de Moreno", "Tepatitlán de Morelos", "El Salto", "Ocotlán",
    // Michoacán
    "Morelia", "Uruapan", "Zamora", "Lázaro Cárdenas", "Apatzingán", "Zitácuaro", "Pátzcuaro",
    // Morelos
    "Cuernavaca", "Cuautla", "Jiutepec", "Temixco", "Yautepec",
    // Nayarit
    "Tepic", "Bahía de Banderas", "Compostela", "Tecuala", "Xalisco",
    // Nuevo León
    "Monterrey", "San Pedro Garza García", "San Nicolás de los Garza", "Guadalupe",
    "Apodaca", "General Escobedo", "Santa Catarina", "Linares", "García", "Juárez",
    // Oaxaca
    "Oaxaca de Juárez", "Salina Cruz", "Tuxtepec", "Juchitán de Zaragoza",
    "Bahías de Huatulco", "Puerto Escondido",
    // Puebla
    "Puebla", "Tehuacán", "Atlixco", "San Pedro Cholula", "San Andrés Cholula",
    "San Martín Texmelucan", "Amozoc", "Izúcar de Matamoros", "Teziutlán",
    // Querétaro
    "Santiago de Querétaro", "San Juan del Río", "Corregidora", "El Marqués",
    "Tequisquiapan", "Cadereyta de Montes",
    // Quintana Roo
    "Cancún", "Playa del Carmen", "Chetumal", "Cozumel", "Tulum", "Isla Mujeres", "Puerto Morelos",
    // San Luis Potosí
    "San Luis Potosí", "Ciudad Valles", "Matehuala", "Soledad de Graciano Sánchez", "Rioverde",
    // Sinaloa
    "Culiacán", "Mazatlán", "Los Mochis", "Guasave", "Navolato", "Guamúchil",
    // Sonora
    "Hermosillo", "Ciudad Obregón", "Nogales", "San Luis Río Colorado", "Navojoa",
    "Guaymas", "Puerto Peñasco", "Caborca", "Empalme",
    // Tabasco
    "Villahermosa", "Cárdenas", "Comalcalco", "Macuspana", "Paraíso",
    // Tamaulipas
    "Ciudad Victoria", "Tampico", "Reynosa", "Matamoros", "Nuevo Laredo",
    "Ciudad Madero", "Altamira", "Río Bravo", "San Fernando",
    // Tlaxcala
    "Tlaxcala", "Apizaco", "Huamantla", "Chiautempan", "Zacatelco",
    // Veracruz
    "Xalapa", "Veracruz", "Boca del Río", "Coatzacoalcos", "Córdoba", "Orizaba",
    "Poza Rica", "Tuxpan", "Minatitlán", "Papantla", "Martínez de la Torre",
    "San Andrés Tuxtla", "Cosamaloapan", "Pánuco",
    // Yucatán
    "Mérida", "Valladolid", "Progreso", "Tizimín", "Umán", "Kanasín",
    // Zacatecas
    "Zacatecas", "Fresnillo", "Guadalupe", "Jerez", "Sombrerete",
  ],
};
